import { UnderlyingUniverse } from 'components/underlyingUniverse/UnderlyingUniverse';
import { FC } from 'react';

const UnderlyingUniverseRoute: FC = () => (
  <div className="page-container w-100 h-100">
    <UnderlyingUniverse />
  </div>
);

export default UnderlyingUniverseRoute;
